import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pt from '@/langs/pt'
import en from '@/langs/en'

Vue.use(VueI18n)

const messages = {
    'pt': pt,
    'en': en,
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'pt', // set fallback locale
    messages, // set locale messages
})

export default i18n